import React from 'react';
// Init Configuration
import { get } from '../../Storage';
var AppSettings = get();
var componentName = AppSettings.appId + '<Data>';
var styles = AppSettings.styles;


class Data extends React.Component {
    constructor(props) {
        super(props);
       this.state = {
        expanded: false
       }
        this.toggleExpandedTicket = this.toggleExpandedTicket.bind(this);
    }

    toggleExpandedTicket() {
        var newState = !this.state.expanded;
        this.setState(
            { 
                expanded: newState 
            });
        }

    render(){
        return(
            <>
                <div key={this.props.data + '_data'} className='mg-bet-date' onClick={this.toggleExpandedTicket}>
                    <span>{this.props.data}</span>
                    {this.state.expanded ? 
                    <i className='fa-mg fa-mg-chevron-down'></i>
                    :
                    <i className='fa-mg fa-mg-chevron-up'></i>
                    }
                </div>
                <div key={this.props.data} className={'userBoxBetTicketContainer ' + (this.state.expanded ? 'mg-hide' : '')}>
                    {this.props.ticketList}
                </div>
            </>
        );
    }
}

Data.displayName = componentName;

Data.propTypes = {
};

// default props
Data.defaultProps = {
    initiallyExpandedTicket: true
};

export default Data;